import React from 'react';
import PatientFormTemplate from './components/PatientFormTemplate';

export default function PatientForensicHistoryForm() {
    return (
        <PatientFormTemplate formTitle="You and the Law" />
    );
}